import Immutable from 'immutable'
import moment from 'moment'

export const CouponRecord = Immutable.Record({
  code: '',
  dateAdded: '',
  dateUpdated: '',
  effectiveFor: null,
  expression: null,
  id: null,
  maxUses: 0,
  name: '',
  periodAbsolute: 0,
  periodPercentage: 0,
  setupAbsolute: 0,
  setupPercentage: 0,
  totalUses: 0,
  validUntil: null,
}, 'Coupon')

export default function createCoupon({
  effectiveFor,
  dateAdded,
  dateUpdated,
  maxUses,
  periodAbsolute,
  periodPercentage,
  setupAbsolute,
  setupPercentage,
  totalUses,
  validUntil,
  ...data
}) {
  return new CouponRecord({
    effectiveFor: effectiveFor ? moment.duration(effectiveFor) : null,
    dateAdded: moment(dateAdded),
    dateUpdated: moment(dateUpdated),
    maxUses: parseInt(maxUses, 10),
    periodAbsolute: parseFloat((periodAbsolute || 0).toFixed(2)),
    periodPercentage: parseInt(periodPercentage, 10) || 0,
    setupAbsolute: parseFloat((setupAbsolute || 0).toFixed(2)),
    setupPercentage: parseInt(setupPercentage, 10) || 0,
    totalUses: parseInt(totalUses, 10),
    validUntil: validUntil ? moment(validUntil) : null,
    ...data,
  })
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/records/Coupon.js